import { Button } from '@/components/ui/button';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { templateSections } from '@/config/templateConfig';

const HistoryView = ({ template, revisions }) => {
  const section = templateSections['history'];

  const fieldsToShow = [];

  section.items
    .filter(({ required }) => required)
    .forEach((field) => {
      fieldsToShow.push(field);
    });

  section.items
    .filter(({ required }) => !required)
    .forEach((field) => {
      if (template.config && template.config[field.key] === true) {
        fieldsToShow.push(field);
      }
    });

  // Real history rows: one per revision, sourced from the revision's linked
  // change control (serial, detailChanges, QA approver). Falls back to the
  // placeholder row for unreleased documents (no revisions passed yet).
  const hasRevisions = revisions && revisions.length > 0;
  const rows = hasRevisions
      ? revisions.map((revision) => {
          const control = revision.controls?.[0] || null;
          return {
            id: control?.serial || `Rev ${revision.revision}`,
            revision: String(revision.revision).padStart(2, '0'),
            summaryOfChanges: control?.detailChanges || 'Initial Release',
            preparedBy: revision.preparedByName || '',
            reviewedBy: control?.reviewedByName || '',
            approvedBy: control?.approvedByName || '',
          };
        })
      : [
          {
            id: '[CC Number TBD]*',
            revision: '01',
            summaryOfChanges: 'Initial Release',
            preparedBy: '[Prepared By TBD]*',
            reviewedBy: '[Reviewed By TBD]*',
            approvedBy: '[Approved By TBD]*',
          },
        ];

  return (
    <div className="space-y-4">
      <div className="rounded-md border">
        <Table>
          <TableHeader>
            <TableRow>
              {fieldsToShow.map((template) => (
                <TableHead key={template.key}>
                  <Button
                    variant="ghost"
                    className="h-auto p-0 font-semibold hover:bg-transparent"
                  >
                    {template.label}
                  </Button>
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map(
              ({
                id,
                revision,
                summaryOfChanges,
                preparedBy,
                reviewedBy,
                approvedBy,
              }) => (
                <TableRow key={id}>
                  <TableCell>{id}</TableCell>
                  <TableCell>
                    <a className="underline" href="#">
                      {revision}
                    </a>
                  </TableCell>
                  <TableCell>{summaryOfChanges}</TableCell>
                  {template.config['preparedBy'] && (
                    <TableCell>{preparedBy}</TableCell>
                  )}
                  {template.config['reviewedBy'] && (
                    <TableCell>{reviewedBy}</TableCell>
                  )}
                  {template.config['approvedBy'] && (
                    <TableCell>{approvedBy}</TableCell>
                  )}
                </TableRow>
              )
            )}
          </TableBody>
        </Table>
      </div>
      {!hasRevisions && (
        <div className="text-sm text-muted-foreground">
          * These values will be updated upon the release of this document.
        </div>
      )}
    </div>
  );
};

export default HistoryView;
